module.exports = __webpack_public_path__ + "static/img/6.4c04cf4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/7/3/zh/6.png
// module id = 0Pvg
// module chunks = 0